// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1C29P","label":"Category_label__2NEMs","content":"Category_content__3x1UB","header":"Category_header__D_K72","location":"Category_location__-My1P"};